<div class="usa-accordion" >
  <h4 class="usa-accordion__heading">
    <button class="usa-accordion__button filter-category-button"
      attr.aria-expanded="{{filterCategory.isExpanded}}"
      (click)="expandClick()"
      arrr.aria-controls="filterParticipantsList">
      {{title}}
    </button>
  </h4>
  @if (filterCategory.isExpanded) {
    <div id="filterParticipantsList" class="usa-accordion__content usa-prose content-max-height">
      <ul class="usa-list usa-list--unstyled">
        <li class="padding-left-205 margin-top-neg-3">
          <h4  id="{{rangeTitleId}}" class="margin-bottom-0">
            {{rangeTitle}}
          </h4>
          <efast-errormessage [efastErrorMsg]="errorMsg"
            [efastErrorState]="errorFound1 || errorFound2">
          </efast-errormessage>
          <div class="filter-input-box margin-bottom-1">
            <efast-field-inputtext [efastErrorState]="errorFound1"
              [efastMaxLength]="9"
              [efastErrorMsg]="errorMsg"
              [efastLabel]=""
              efastFieldId="applyFromValueId"
              [(efastModel)] ="applyFromValue"
              efastAriaLabelledBy={{rangeTitleId}}
              class="filter-input">
            </efast-field-inputtext>
            <p class="margin-x-105">
              {{rangeToLbl}}
            </p>
            <efast-field-inputtext [efastErrorState]="errorFound2"
              [efastMaxLength]="9"
              [efastErrorMsg]="errorMsg"
              [efastLabel]=""
              efastFieldId="applyToValueId"
              [(efastModel)] ="applyToValue"
              efastAriaLabelledBy={{rangeTitleId}}
              class="filter-input">
            </efast-field-inputtext>
          </div>
          <br>
            <button class="usa-button  usa-button--active" type="submit" (click)='apply()' >
              <div>
                <span [innerHTML]="applyBtn"></span>
              </div>
            </button>
          </li>
        </ul>
      </div>
    }
  </div>
